<template >
  <div class="justify-content-between align-items-center content-sidebar px-1 py-1">
    <hr>
        <b-form>
            <b-row>

                <b-col
                    cols="12"
                    class="mb-2"
                >
                    <h5 class="mb-0">
                        ATUALIZAR CENTRO DE TRABALHO
                    </h5>
                </b-col>

                <b-col md="12">
                    <b-form-group
                    label="Nome"
                    label-for="name"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                    <b-form-input
                    id="name"
                    v-model="name"
                    placeholder="Welders"
                    :state="nomeState"
                    />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label="Centro de Custo"
                    label-for="costCenter"
                    :class="stateErrorCentroCusto && 'invalid'"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="costCenter"
                        :options="contextoList.cost_centers.map((item) => {return {label: item.name, value: item.id}})"
                        />
                        
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label="Líder"
                    label-for="leader"
                    invalid-feedback="Campo obrigatório"
                    :class="stateErrorLider && 'invalid'"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="leader"
                        :options="contextoList.leaders.map((item) => {return {label: item.name, value: item.id}})"
                        
                      />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label="Operadores"
                    label-for="operators"
                    invalid-feedback="Campo obrigatório"
                    :class="stateErrorOperador && 'invalid'"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="operators"
                        :options="contextoList.operators.map((item) => {return {label: item.name, value: item.id}})"
                        multiple
                      />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Família"
                    label-for="familia"
                    :class="stateErrorFamilia && 'invalid'"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="familia"
                        :options="contextoList.families.map((item) => {return {label: item, value: item}})"
                        multiple
                      />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label="Modelo"
                    label-for="modelo"
                    :class="stateErrorModelo && 'invalid'"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="modelo"
                        :options="contextoList.models.map((item) => {return {label: item, value: item}})"
                        multiple
                      />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <b-button v-if="!sendingForm"
                        variant="primary"
                        class="form-control"
                        @click="updateWorkcenter(currentWorkcenterId)"
                        >
                        Salvar
                        </b-button>

                    <b-button v-if="sendingForm"
                        variant="primary"
                        disabled
                        class="form-control"
                    >
                        <b-spinner small />
                        Loading ...
                    </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { TheMask } from 'vue-the-mask'
import vSelect from 'vue-select'

import {
  BAvatar, BListGroup, BListGroupItem, BCardText, BForm, BFormGroup, BFormInput, BFormSelect, BButton, BSpinner, BRow, BCol, BFormTextarea,
} from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
    BListGroup,
    BListGroupItem,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BSpinner,
    BRow,
    BCol,
    BFormTextarea,
    TheMask,
    flatPickr,
    ToastificationContent,
    vSelect
  },
  directives: {
    Ripple,
  },
  props:{
    currentWorkcenterId: {
      type: String,
    },
    contextoList:{
      type: Array
    },
    currentWorkcenter:{
      type: Array
    }
  },
  watch:{
    currentWorkcenter(){
      this.leader = this.contextoList.leaders.filter(item => item.id == this.currentWorkcenter[0].leader_id).map((item) => {return {label: item.name, value: item.id}})[0];

      this.name = this.currentWorkcenter[0].name;

      this.costCenter = this.contextoList.cost_centers.filter(item => item.id == this.currentWorkcenter[0].cost_center_id).map((item) => {return {label: item.name, value: item.id}})[0]

      this.operators = this.contextoList.operators.filter(item => this.currentWorkcenter[0].operators.some((el) => item.id === el)).map((item) => {return {label: item.name, value: item.id}});

      this.familia = this.contextoList.families.filter(item => this.currentWorkcenter[0].family.some((el) => item === el)).map((item) => {return {label: item, value: item}});

      this.modelo = this.contextoList.models.filter(item => this.currentWorkcenter[0].models.some((el) => item === el)).map((item) => {return {label: item, value: item}});

      this.validaCampos()
    }
  },
  data() {
    return {
      currentSite: JSON.parse(localStorage.getItem('currentSite')),
      name: '',
      sendingForm: false,
      data: [],
      leader: null,
      operators: null,
      costCenter:null,
      familia: null,
      nomeState:null,
      stateErrorOperador:false,
      stateErrorLider:false,
      stateErrorCentroCusto:false,
      stateErrorFamilia: false,
      stateErrorModelo:false,
      modelo:null,
    }
  },
  methods: {
    validaCampos(){
      this.nomeState = this.name ? null : false 
      this.stateErrorLider = this.leader ? false : true
      this.stateErrorOperador = this.operators.length > 0 ? false : true
      this.stateErrorCentroCusto = this.costCenter ? false : true
      this.stateErrorFamilia = this.familia.length > 0 ? false : true
      this.stateErrorModelo = this.modelo.length > 0  ? false : true
    },
    updateWorkcenter(id){
      this.validaCampos();
        if(this.nomeState != false && !this.stateErrorOperador && !this.stateErrorLider && !this.stateErrorCentroCusto  && !this.stateErrorFamilia && !this.stateErrorModelo){

          let operatosIds = []
          this.operators.forEach(el => operatosIds.push(el.value))
          let familiaIds = []
          this.familia.forEach(el => familiaIds.push(el.value))
          let modelsIds = []
          this.modelo.forEach(el => modelsIds.push(el.value))

          this.sendingForm = true
          this.$http.put(`/api/workcenters/${id}`,
          {name: this.name, 
          leader_id: this.leader.value,
          operators_id: operatosIds,
          cost_center_id: this.costCenter.value,
          family: familiaIds,
          model:modelsIds
          }).then(res => { 
                  this.sendingForm = false
                  this.$emit('refetch-data')
                  this.$emit('show-message')
                  this.showToast('Good job!', 'SmileIcon', 'Production progress updated successfully', 'success')
              })
              .catch((error) => {
                  this.sendingForm = false
                  this.showToast('Error!', 'FrownIcon', error.response.data.message, 'danger')
              })
        }
    },
    showToast(title, icon, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: icon,
          text: text,
          variant,
        },
      })
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

</style>